export const isSuggestedElementsHaveChild = (elementId, storedPageAllHtmlData) => {
  const findParentEleDetails = storedPageAllHtmlData.find((el) => el.id === elementId);

  let isSiblingsAvailable = false;
  if (findParentEleDetails && findParentEleDetails?.siblings?.length > 0) {
    findParentEleDetails.siblings.forEach((sibElement) => {
      for (let i = 0; i < storedPageAllHtmlData.length; i++) {
        if (storedPageAllHtmlData[i].id == sibElement.id) {
          isSiblingsAvailable = true;
          break;
        }
      }
    });
  }
  return isSiblingsAvailable;
};

export const getKeywordDificultyColorRange = (score) => {
  switch (true) {
    case score <= 24:
      return '#EFBF2E';
    case score <= 49:
      return '#F2994A';
    case score <= 74:
      return '#E57310';
    case score <= 90:
      return '#EB5757';
    case score <= 100:
      return '#EB5757';
    default:
      return '';
  }
};

export const getKeywordSuitabilityRatingColorRange = (score) => {
  switch (true) {
    case score <= 49:
      return '#E57310';
    case score > 49 && score < 80:
      return '#EFBF2E';
    case score >= 80:
      //#219653
      return '#51D497';
    default:
      return '';
  }
};

export const getKeywordTypeCount = (list) => {
  let brandedCount = 0;
  let nonBrandedCount = 0;
  // skip subkeywords
  const keywordClusterList = list.filter((kw) => !kw.sub_keyword);
  keywordClusterList.forEach((item) => {
    if (item.is_branded) {
      brandedCount++;
    } else {
      nonBrandedCount++;
    }
  });
  return {
    brandedTargetedKeywordCount: brandedCount,
    nonBrandedTargetedKeywordCount: nonBrandedCount,
  };
};

export const getHeaderString = (details, isBrandedIncluded) => {
  const countArray = [];
  if (details.nonBrandedTargetedKeywordCount) {
    countArray.push(`${details.nonBrandedTargetedKeywordCount} non-branded keywords`);
  }
  if (details.brandedTargetedKeywordCount && isBrandedIncluded) {
    countArray.push(`${details.brandedTargetedKeywordCount} branded keywords`);
  }
  if (details.newKeywordsCount) {
    countArray.push(`${details.newKeywordsCount} new non-branded keywords`);
  }
  if (details.newBrandedKeywordsCount && isBrandedIncluded) {
    countArray.push(`${details.newBrandedKeywordsCount} new branded keywords`);
  }
  return countArray.join(', ');
};

export const getPotentialHeaderString = (potentialData, isBrandedIncluded) => {
  const dataDetails = getKeywordTypeCount(potentialData);
  const countArray = [];
  if (dataDetails.nonBrandedTargetedKeywordCount) {
    countArray.push(`${dataDetails.nonBrandedTargetedKeywordCount} non-branded keywords`);
  }
  if (dataDetails.brandedTargetedKeywordCount && isBrandedIncluded) {
    countArray.push(`${dataDetails.brandedTargetedKeywordCount} branded keywords`);
  }
  return countArray.join(', ');
};

export const getRecalculateCountString = (targetdKeywordCountData) => {
  const countArray = [];
  if (targetdKeywordCountData.newKeywordsCount) {
    countArray.push(`${targetdKeywordCountData.newKeywordsCount} non-branded`);
  }
  if (targetdKeywordCountData.newBrandedKeywordsCount) {
    countArray.push(`${targetdKeywordCountData.newBrandedKeywordsCount} branded`);
  }
  return countArray.join(', ');
};
